import React from 'react';
import DataTable from "../../components/data-table/DataTable";
import {getBusinessUnits, navLinks} from "../../services/organization";
import LeftBar from "../../components/left-bar/LeftBar";
import NavigationLinks from "../../components/navigation-links/NavigationLinks";
import Content from "../../components/content/Content";
import SearchField from "../../components/fields/SearchField";
import ActionButton from "../../components/button/ActionButton";

const columnData = [
    { id: 'name', numeric: false, disablePadding: false, label: 'Название' },
    { id: 'typeText', numeric: false, disablePadding: false, label: 'Тип' },
    { id: 'address', numeric: false, disablePadding: false, label: 'Адрес' },
    { id: 'region', numeric: false, disablePadding: false, label: 'Регион' },
    { id: 'price1Name', numeric: false, disablePadding: false, label: 'Осн. прайс' },
    { id: 'price2Name', numeric: false, disablePadding: false, label: 'Доп. прайс' },
    { id: 'active', label: 'Активность' },
];

class ParlourListPage extends React.Component {

    state = {
        search: {
            search: null
        },
        refreshTable: false
    };

    handleChange = prop => event => {
        this.setState({
            search: {
                ...this.state.search,
                [prop]: event.target.value,
            }
        });
    };

    handleClickSearch = () => {
        this.setState(state => ({ refreshTable: !state.refreshTable }));
    };

    handleAdd = () => {
        this.props.history.push(`/organization/parlours/view/0`);
    };

    getTableData = (...params) => {
        const {search} = this.state;
        return getBusinessUnits(search, ...params);
    };

    render() {
        const { search, refreshTable } = this.state;

        return (
            <React.Fragment>
                <LeftBar navigationLinks={<NavigationLinks links={navLinks}/>}>
                    <SearchField
                        value={search.search}
                        onChange={this.handleChange('search')}
                        onClick={this.handleClickSearch}
                        label="Поиск"
                    />
                    <br />
                    <br />
                    <ActionButton onClick={this.handleAdd}>Добавить</ActionButton>
                </LeftBar>
                <Content title="Бизнес Юниты">
                    <DataTable
                        columnData={columnData}
                        dataFunc={this.getTableData}
                        linkTemplate={(item) => `/organization/parlours/view/${item.id}`}
                        selector={false}
                        refresh={refreshTable}
                    />
                </Content>
            </React.Fragment>
        );
    }
}

export default ParlourListPage;
